export const MuiInputBase = {
    styleOverrides: {
        root: {
            borderWidth: 0,
        },
        input: ({ theme }) => ({
            color: theme.palette.text.primary,
            // Text shadow for TextField
            // textShadow: 'rgb(0, 0, 0) 0px 0px 0px',
            padding: '0.375rem 0.75rem',
            paddingTop: '0.375rem',
            paddingBottom: '0.375rem',
            paddingRight: '0.75rem',
            paddingLeft: '0.75rem',
            lineHeight: '1.5rem',
            height: '1.5rem',
            '::placeholder': {
                color: theme.palette.text.muted,
                opacity: 1,
                textShadow: 'none',
            },
        }),
        multiline: {
            padding: 0,
        },
        adornedEnd: ({ theme }) => ({
            color: theme.palette.text.muted,
        }),
    },
};
